import React from "react";

const LoadingPage = () => {
  return (
    <main style={{ padding: "1rem" }}>
      <p>Loading...</p>
    </main>
  );
};

export default LoadingPage;
